module.exports = __webpack_public_path__ + "static/media/alis03.9788b583.jpg";